import React from 'react'
import { decamelizeKeys } from 'humps'

import format from '@st-operations/uikit/lib/format.js'
import DestinationsCard from './card/index.jsx'

import './styles.scss'

export const FIELDS = {
  adelphic: ['adelphicAdvertiserId', 'adelphicCpm'],
  appnexus: ['appnexusSeatId', 'appnexusPricingCategoryId'],
  ttd: ['ttdPartnerId', 'ttdRateType', 'ttdCpmRate', 'ttdPercentOfMediaCostRate'],
  ttd_contextual: ['ttdPartnerId', 'ttdContextualPriceId'],
  yahoo: ['yahooFee', 'yahooUsers'],
  basis: ['basisPrice', 'basisAdvertiserId'],
  openx: ['openxDemandPartner', 'openxBuyerId', 'openxDealPrice', 'openxCpm'],
}

// use these for backwards compatibility where
// audiences have been saved without an api integration
export const DESTINATIONS_API_INTEGRATIONS = {
  // adelphic
  'Adelphic Global IP': 'adelphic',

  // appnexus
  AppNexus: 'appnexus',
  'AppNexus Android ID': 'appnexus',
  'AppNexus IOS ID': 'appnexus',
  'Appnexus IP': 'appnexus',
  'Contextual Xandr': 'appnexus',

  // ttd
  'The Trade Desk': 'ttd',
  'TTD Android Id': 'ttd',
  'TTD ID5 UUID': 'ttd',
  'TTD Ios Id': 'ttd',
  'TTD UID V2': 'ttd',

  // yahoo
  'Yahoo Verizon Android ID': 'yahoo',
  'Yahoo Verizon HEM': 'yahoo',
  'Yahoo Verizon ID': 'yahoo',
  'Yahoo Verizon IOS ID': 'yahoo',

  //Basis
  Basis: 'basis',
  'Basis Android': 'basis',
  'Basis ios': 'basis',

  //OpenX
  'Contextual OpenX': 'openx',
}

const SelectedDestinations = ({
  audience,
  setAudience,
  onInputChange,
  schema,
  disabled,
  sizes,
}) => {
  const destinationSizesSlugged =
    audience?.destinationSizes &&
    Object.fromEntries(
      Object.entries(decamelizeKeys(audience.destinationSizes)).map(([key, value]) => [
        key.replaceAll(/_/g, '-'),
        value,
      ])
    )

  const getSize = (destination) =>
    format('metric', destinationSizesSlugged?.[destination.slug] ?? sizes?.[destination._id])

  const apiIntegrations = audience?.destinations?.reduce((acc, destination) => {
    const apiIntegration =
      destination.apiIntegration || DESTINATIONS_API_INTEGRATIONS[destination.name]

    if (!apiIntegration) {
      return {
        ...acc,
        noConfig: [...(acc.noConfig || []), destination],
      }
    }

    return {
      ...acc,
      [apiIntegration]: [...(acc[apiIntegration] || []), destination],
    }
  }, {})

  const handleRemove = (value) =>
    setAudience((audience) => ({
      ...audience,
      destinations: audience.destinations.filter((destination) => destination._id !== value._id),
    }))

  return (
    <div>
      <For each="apiIntegration" index="index" of={Object.keys(apiIntegrations)}>
        <DestinationsCard
          key={apiIntegration}
          destinations={apiIntegrations[apiIntegration]}
          fields={FIELDS[apiIntegration]}
          onChange={onInputChange}
          schema={schema}
          item={audience}
          disabled={disabled}
          getSize={getSize}
          handleRemove={handleRemove}
        />
      </For>
    </div>
  )
}

export default SelectedDestinations
